import { v4 as uuid } from "uuid";
import { CargoSubtype } from "./cargo-subtype";
import { ContainerAlertEntity, ContainerAlertType } from "./container-alert";

interface AlertDateBuilderStep {
  setAlertDate: (value: Date) => ContainerAlertBuilder;
}

export interface ContainerBuilderStep {
  setContainer: (value: string) => RegionBuilderStep;
}

interface RegionBuilderStep {
  setRegion: (value: string) => AlertTypeBuilderStep;
}

interface AlertTypeBuilderStep {
  setAlertType: (value: ContainerAlertType) => AlertValueBuilderStep;
}

interface AlertValueBuilderStep {
  setAlertValue: (value: number) => AlertUomBuilderStep;
}

interface AlertUomBuilderStep {
  setAlertUom: (value: string) => AlertDateBuilderStep;
}

export class ContainerAlertBuilder
  implements
    AlertUomBuilderStep,
    AlertValueBuilderStep,
    AlertTypeBuilderStep,
    RegionBuilderStep,
    ContainerBuilderStep,
    AlertDateBuilderStep
{
  id: string;

  containerId!: string;
  regionId!: string;
  alertType!: ContainerAlertType;
  alertValue!: number;
  alertUom!: string;
  alertDate!: Date;

  cargoSubtype?: CargoSubtype;
  dispatchRequestId?: string;
  dispatchId?: string;
  comment?: string;
  createdById?: string;
  triggerObjectId?: string;
  triggerObjectType?: string;
  createDate = new Date();
  lastModifiedDate = new Date();

  constructor(id: string | undefined = uuid()) {
    this.id = id;
  }

  setCargoSubtype(value: CargoSubtype | undefined): ContainerAlertBuilder {
    this.cargoSubtype = value;
    return this;
  }

  setDispatchRequestId(value: string | undefined): ContainerAlertBuilder {
    this.dispatchRequestId = value;
    return this;
  }

  setDispatchId(value: string | undefined): ContainerAlertBuilder {
    this.dispatchId = value;
    return this;
  }

  setComment(value: string | undefined): ContainerAlertBuilder {
    this.comment = value;
    return this;
  }

  setCreatedById(value: string | undefined): ContainerAlertBuilder {
    this.createdById = value;
    return this;
  }

  setTriggerObjectId(value: string | undefined): ContainerAlertBuilder {
    this.triggerObjectId = value;
    return this;
  }

  setTriggerObjectType(value: string | undefined): ContainerAlertBuilder {
    this.triggerObjectType = value;
    return this;
  }

  setCreateDate(value: Date): ContainerAlertBuilder {
    this.createDate = value;
    return this;
  }

  setLastModifiedDate(value: Date): ContainerAlertBuilder {
    this.lastModifiedDate = value;
    return this;
  }

  setContainer(value: string): RegionBuilderStep {
    this.containerId = value;
    return this;
  }

  setRegion(value: string): AlertTypeBuilderStep {
    this.regionId = value;
    return this;
  }

  setAlertType(value: ContainerAlertType): AlertValueBuilderStep {
    this.alertType = value;
    return this;
  }

  setAlertValue(value: number): AlertUomBuilderStep {
    this.alertValue = value;
    return this;
  }

  setAlertUom(value: string): AlertDateBuilderStep {
    this.alertUom = value;
    return this;
  }

  setAlertDate(value: Date): ContainerAlertBuilder {
    this.alertDate = value;
    return this;
  }

  build(): ContainerAlertEntity {
    return ContainerAlertEntity.create(this);
  }
}
